import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import placeholder from "../../assets/images/fashion/product/12.jpg"; 
const ParticepentList = ({ myData }) => {
  const [data, setData] = useState();
  useEffect(() => {
    setData(myData);
  }, [myData]);

  const columnDefs = [
    {
      name: "Image",
      cell: (row) => <ProfileImage row={row} />,
    },
    {
      name: "Username",
      selector: (row) => row.username,
      sortable: true,
    },
    {
      name: "User Type",
      selector: (row) => row.userType,
      sortable: true,
    },
  ];

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

const ProfileImage = ({ row }) => {
  return (
    <div className="profile-image">
      <img src={row.profile ? row.profile : placeholder} alt="logo" />
    </div>
  );
};

export default ParticepentList;
